import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "components/Loader/Loader";
import { isAuthRoute, isRouteAllowed, isUnguardedRoute } from "utils/routeAccess";

const ACCESS_DENIED_TOAST_ID = "route-access-denied";

// Redirects to the landing page when the current route is not in the user's permission menu
export default function RouteGuard({ children }) {
  const { pathname } = useLocation();
  const allowedRoutes = useSelector((state) => state?.navbar?.allowedRoutes);

  const isDenied =
    !isAuthRoute(pathname) &&
    !isUnguardedRoute(pathname) &&
    !!allowedRoutes &&
    !isRouteAllowed(pathname, allowedRoutes);

  useEffect(() => {
    // Fixed toastId prevents duplicates (StrictMode double effects, repeated redirects)
    if (isDenied) {
      toast.error("You don't have permission to access this page.", {
        toastId: ACCESS_DENIED_TOAST_ID,
      });
    }
  }, [isDenied, pathname]);

  // Just logged in from an auth page; go home without the permission toast
  if (isAuthRoute(pathname)) return <Navigate to="/" replace />;

  if (isUnguardedRoute(pathname)) return children;

  // Permission menu is still loading (fetched by Navbar)
  if (!allowedRoutes) return <Loader />;

  if (isDenied) {
    return <Navigate to="/" replace />;
  }

  return children;
}
